<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton
      class="width100"
      :loading="true"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div
          class="
            width100
            margin-auto
            backwhite
            margin-top10
            pad-top20 pad-bot10
            alldigital
            border-rd3
          "
        >
          <el-table :data="pages" class="eltable width98 margin-auto f14">
            <el-table-column label="企业名称" align="left">
              <template slot-scope="scope">
                <span class="bluecolor">{{
                  scope.row.company_name == null ? "" : scope.row.company_name
                }}</span>
              </template></el-table-column
            >
            <el-table-column label="监控时间" align="center"
              ><template slot-scope="scope">{{
                scope.row.create_time.substring(0, 10)
              }}</template></el-table-column
            >
            <el-table-column label="数据更新" align="center"
              ><template slot-scope="scope">{{
                scope.row.update_time.substring(0, 10)
              }}</template></el-table-column
            >
            <el-table-column label="数量" align="center" prop="create_time"
              ><template slot-scope="scope">
                发明专利:{{ scope.row.fmzl_count }} 实用新型：{{
                  scope.row.syxx_count
                }}
                外观专利：{{ scope.row.wgzl_count }}</template
              ></el-table-column
            >
            <el-table-column
              label="操作"
              align="center"
              width="320"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="todialog(scope.row)"
                  >取消关注</span
                >
                <span
                  class="pad-left10 bluecolor cursorpointer"
                  @click="dialogVisibledrawer = true"
                >
                  <span
                    @click="saveindex(scope.row)"
                    v-if="scope.row.ent_id == 0"
                    >分享给企业</span
                  >
                </span>
                <span
                  @click="nullshare(scope.row)"
                  class="pad-left10 bluecolor cursorpointer"
                  v-if="scope.row.ent_id != 0"
                  >取消共享</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="flex-betweennowrap pad-top20 width98 margin-auto">
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
              v-if="total != 0"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <el-dialog
      title="请选择企业"
      :visible.sync="dialogVisibledrawer"
      :close-on-click-modal="false"
      :show-close="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
      class="drawerbox"
    >
      <div class="newenterprises">
        <el-input
          placeholder="请输入内容"
          v-model="input3"
          class="input-with-select inputinner"
          @input="oninput()"
        >
        </el-input>
        <i
          slot="prefix"
          class="iconfont iconfonts icon-search pad-right20"
          @click="searchbut()"
        ></i>
      </div>
      <div class="enterprisebox" @scroll="scrollEvent">
        <div
          class="newenterprise"
          @click="onConfirm(index)"
          v-for="(item, index) in page"
          :key="index"
        >
          {{ item.company }}
        </div>
      </div>
      <div class="width98 margin-auto textalign-right">
        <el-button @click="dialogVisibledrawer = false">取 消</el-button>
        <el-button
          class="margin-top20"
          type="primary"
          @click="dialogVisibledrawer = false"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { boundEnterprise } from "@/api/personal/personal.api";
import {
  entmonitormymonitor,
  entmonitordelete,
  entmonitorshare,
  entmonitorclose,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibledrawer: false,
      direction: "btt",
      titlespan: "请选择企业",
      input3: "",
      page: "",
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      enpriseid: "",
      input: "",
      companytitle: "",
      thisNums: 1,
      page1: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  components: {
    callback,
  },

  methods: {
    //滚动条触发事件
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // // 获取企业
        boundEnterprise({ limit: 30, page: ++this.thisNums }).then((res) => {
          if (res.data.code == 200) {
            // this.page = res.data.data.data;
            if (res.data.data.data.length == 0) {
              return;
            } else {
              this.page1 = res.data.data.data;
              this.page1.forEach((i) => {
                this.page.push(i);
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 取消关注
    todialog(row) {
      this.$confirm("此操作将取消关注, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entmonitordelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消关注成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 取消分享
    nullshare(row) {
      this.$confirm("此操作将取消分享, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entmonitorclose({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消分享成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 保存id
    saveindex(row) {
      this.enpriseid = row.id;
    },
    //分享
    onConfirm(index) {
      entmonitorshare({
        id: this.enpriseid,
        ent_id: this.page[index].ent_id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisibledrawer = false;
          this.$message({
            showClose: true,
            message: "分享成功",
            type: "success",
          });
          this.refresh();
        } else {
          this.dialogVisibledrawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    searchbut() {
      if (this.input3 != "") {
        // // 获取企业
        boundEnterprise({ _keywords: this.input3 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    oninput() {
      if (this.input3 == "") {
        // // 获取企业
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.title = this.page[0].company;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    Submitfrom() {},

    // 分页
    currentchange(val) {
      this.thisNum = val;
      entmonitormymonitor({
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entmonitormymonitor({
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      // // 获取企业
      boundEnterprise().then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          if (window.sessionStorage.getItem("default") == 0) {
            this.title = "个人版";
          } else {
            this.title = this.page[0].company;
            window.sessionStorage.setItem("companytitle", this.page[0].company);
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      entmonitormymonitor({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.companytitle = window.sessionStorage.getItem("companytitle");

    // // 获取企业
    boundEnterprise().then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        if (window.sessionStorage.getItem("default") == 0) {
          this.title = "个人版";
        } else {
          this.title = this.page[0].company;
          window.sessionStorage.setItem("companytitle", this.page[0].company);
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    this.$loading.show(); // 显示loading
    entmonitormymonitor({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.newenterprise {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 35px;
  color: #767676;
  border-bottom: 1px solid #efefef;
  font-size: 14px;
  padding: 0 10px 0 20px;
}
.newenterprise:hover {
  background: #efefef;
}
.newenterprises {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 35px;
  color: #767676;
  font-size: 14px;
  padding: 0 10px 0 10px;
}
.enterprisebox {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #efefef;
}
/* .enterprisebox::-webkit-scrollbar {
  width: 0 !important;
} */

.el-input {
  width: 100%;
}

.inputinner >>> .el-input__inner {
  border: none;
}
.inputinner >>> .el-button {
  border: none;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.drawerbox >>> .el-dialog__body {
  text-align: center;
  padding: 0 0 20px 0;
}
.drawerbox >>> .el-dialog__header {
  padding: 10px 0 10px 20px;
  border-bottom: 1px solid #efefef;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
</style>